'use strict';
'use es6';
/* eslint no-unused-vars: 0, prefer-rest-params: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _setArity;

var _enforceArity2 = require('../internal/_enforceArity');

var _enforceArity3 = _interopRequireDefault(_enforceArity2);

var _enforceFunction2 = require('../internal/_enforceFunction');

var _enforceFunction3 = _interopRequireDefault(_enforceFunction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @private
 * Creates a function identical to `operation` with length `arity`.
 *
 * @param  {number} arity from 0 to 9
 * @param  {Function} operation
 * @return {Function}
 */
function _setArity(arity, operation) {
  (0, _enforceArity3.default)(arity);
  (0, _enforceFunction3.default)(operation);

  // The implementation here borrows pretty heavily from ramdajs.
  // https://github.com/ramda/ramda/blob/45bb9160b0aa2ed3bc5755d906024eb0337169a2/src/internal/_arity.js
  switch (arity) {
    case 0:
      return function arity0() {
        return operation.apply(undefined, arguments);
      };
    case 1:
      return function arity1(a) {
        return operation.apply(undefined, arguments);
      };
    case 2:
      return function arity2(a, b) {
        return operation.apply(undefined, arguments);
      };
    case 3:
      return function arity3(a, b, c) {
        return operation.apply(undefined, arguments);
      };
    case 4:
      return function arity4(a, b, c, d) {
        return operation.apply(undefined, arguments);
      };
    case 5:
      return function arity5(a, b, c, d, e) {
        return operation.apply(undefined, arguments);
      };
    case 6:
      return function arity6(a, b, c, d, e, f) {
        return operation.apply(undefined, arguments);
      };
    case 7:
      return function arity7(a, b, c, d, e, f, g) {
        return operation.apply(undefined, arguments);
      };
    case 8:
      return function arity8(a, b, c, d, e, f, g, h) {
        return operation.apply(undefined, arguments);
      };
    case 9:
      return function arity9(a, b, c, d, e, f, g, h, i) {
        return operation.apply(undefined, arguments);
      };
    default:
      return operation;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/internal/_setArity.js
// module id = 362
// module chunks = 2 3